import angular from 'angular';
import mycrmDropdown from './mycrmDropdown';

export default angular
  .module('components.mycrmDropdown', [])
  .component('mycrmDropdown', mycrmDropdown).name;
